import styled from 'styled-components';
import { CloseButton } from '../closeButton';
import { colors, fonts } from '../../theme/styled';
import { media } from '../../theme/media';

export const BannerContainer = styled.div`
  padding: 9px 45px 9px 10px;
  background: ${ colors.yellow };
  text-align: center;
  position: relative;
  font-family: ${ fonts.titleFont };
  font-size: 14px;
  width: 100vw;
  line-height: 1.4;
  z-index: 7;

  ${media.tablet`
    font-size: 16px;
    padding-left: 45px;
  `};

  a {
    position: relative;
    z-index: 100;
    &::before {
      background: ${ colors.red };
      bottom: 0;
      content: '';
      height: 100%;
      position: absolute;
      transform-origin: 50% 100%;
      transform: scale(1, .1);
      transition: .3s transform;
      width: 100%;
      z-index: -1;
    }
    &:hover::before {
      transform: scale(1, 1.1);
    }
  }

  strong {
    font-weight: bold;
    text-transform: uppercase;
    a {
      margin-right: 2px;
    }
    a::before {
      bottom: -10%;
      transform: scale(1, .2);
    }
    a:hover::before {
      transform: scale(1, 1.2);
    }
  }
`;

export const BannerCloseButton = styled(CloseButton)`
  position: absolute;
  background: none;
  top: 0px;
  right: 10px;
  height: 100%;

  button {
    height: 100%;
  }
`;
